import styled from 'styled-components';

const Paragraph = styled.p`
	font-weight: 500;
	color: var(--primary);
	font-size: 1.8rem;
`;

export default Paragraph;
